export default "__VITE_ASSET__122d8b9c__"